export default function PortalStatusBadge({ status }) {
  const key = String(status || "inactive").toLowerCase();
  const cls = key === "active"
    ? "bg-emerald-100 text-emerald-700"
    : key === "invited"
      ? "bg-blue-100 text-blue-700"
      : key === "blocked"
        ? "bg-rose-100 text-rose-700"
        : key === "revoked"
          ? "bg-slate-200 text-slate-700"
          : "bg-amber-100 text-amber-700";

  const label = key === "active"
    ? "Actief"
    : key === "invited"
      ? "Uitnodiging verzonden"
      : key === "blocked"
        ? "Geblokkeerd"
        : key === "revoked"
          ? "Ingetrokken"
          : "Niet actief";

  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>{label}</span>;
}
